module.exports = __webpack_public_path__ + "img/E2 UB3.4f0ea53b.png";